import type { IconNode } from '../types';

/**
 * @name pram
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTguNyA0LjQgMTQuNSAxMCIgLz4KICA8cGF0aCBkPSJNMTMgMTBWMmE4LjEgOC4xIDAgMCAxIDggOHYxYzAgMS43LTEuMyAzLTMgM0g2Yy0xLjcgMC0zLTEuMy0zLTN2LTFoMTgiIC8+CiAgPHBhdGggZD0ibTguMiAxOC40IDMuMy00LjQiIC8+CiAgPGNpcmNsZSBjeD0iNyIgY3k9IjIwIiByPSIyIiAvPgogIDxwYXRoIGQ9Ik0xNS44IDE4LjQgNS42IDQuOEExLjk0IDEuOTQgMCAwIDAgMiA2IiAvPgogIDxjaXJjbGUgY3g9IjE3IiBjeT0iMjAiIHI9IjIiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/pram
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const pram: IconNode = [
  ['path', { d: 'M18.7 4.4 14.5 10', key: '1ajdds' }],
  [
    'path',
    { d: 'M13 10V2a8.1 8.1 0 0 1 8 8v1c0 1.7-1.3 3-3 3H6c-1.7 0-3-1.3-3-3v-1h18', key: '167806' },
  ],
  ['path', { d: 'm8.2 18.4 3.3-4.4', key: '1p3ib0' }],
  ['circle', { cx: '7', cy: '20', r: '2', key: '1xhi4t' }],
  ['path', { d: 'M15.8 18.4 5.6 4.8A1.94 1.94 0 0 0 2 6', key: '76926k' }],
  ['circle', { cx: '17', cy: '20', r: '2', key: 'b76hac' }],
];

export default pram;
